import { get, post, $post } from "./methods.js";

//资讯列表
export function newsList(data) {
    return get("/apiNoAuth/newsInfo/list-0", data);
}

//资讯详情
export function newsDetail(data) {
    return get("/apiNoAuth/newsInfo/getNewsInfo", data);
}
//获取首页轮播
export function getBanner(data) {
    return get("/apiNoAuth/banner/getBannerList", data);
}
//获取首页园区信息
export function getGarden(data) {
    return get("/apiNoAuth/parkInfo/getParkInfoList", data);
}
//获取首页师资培训课程列表
export function getClass(data) {
    return get("/apiNoAuth/classInfo/getClassList", data);
}
// //获取首页绘本
export function getBooks(data) {
    return get("/apiNoAuth/commodity/getCommodity", data);
}
// //获取首页师资培训课程列表
// export function getClass(data) {
//     return get("/apiNoAuth/home/getHomeClassInfo", data);
// }
// //获取首页师资培训课程列表
// export function getClass(data) {
//     return get("/apiNoAuth/home/getHomeClassInfo", data);
// }
//获取首页视频列表
export function getVideoInfo(data) {
    return get("/apiNoAuth/home/getHomeVideoInfo", data);
}
//根据地址查询园区信息
export function getByAddress(data) {
    return get("/apiNoAuth/home/getParkInfoByAddress", data);
}

//获取消息列表
export function getMessage(data) {
    return get("/api/messageInfo/listUserMessage", data);
}

//获取首页搜索
export function getSearch(data) {
    return get("/apiNoAuth/home/searchClassInfo-0", data);
}

//全部标为已读
export function readyRead(data) {
    return post("/api/messageInfo/checkMessageInfo", data);
}

//获取消息状态
export function MessageStatus(data) {
    return get("/apiNoAuth/home/getUserMessageStatus", data);
}
//更新用户留下的消息
export function addCollectInfo(data) {
    return post("/apiNoAuth/infoCollect/addCollectInfo", data);
}

//更新用户留下的消息
export function addFeedback(data) {
    return post("/apiNoAuth/feedback/add", data);
}

//获取示范展示列表（三期接口）
export function getDemonstrateData(data) {
    return get("/apiNoAuth/news/getDemonstrateData", data);
}

//查询新闻动态（三期接口）
export function getNewData(data) {
    return get("/apiNoAuth/news/getNewData-0", data);
}

//查询新闻详情（三期接口）
export function getNewsDetail(data) {
    return get("/apiNoAuth/news/getNewsDetail", data);
}

//合作申请
export function addCooperationApply(data) {
    return $post("/apiNoAuth/news/cooperationApply", data);
}


// WEBPACK FOOTER //
// ./src/api/home.js